/* ODENTIS — numéro RPPS / SIRET obligatoire avant la commande
   ------------------------------------------------------------
   Le champ est dans le panier (tiroir et page panier) : sur le forfait Basic, Shopify n'autorise pas
   de champ personnalisé dans le tunnel de paiement. La valeur est envoyée avec le panier
   (attribut « RPPS ou SIRET ») et apparaît sur la commande, rubrique « Informations supplémentaires ».
   Formats acceptés : RPPS (11 chiffres), ADELI ou SIREN (9 chiffres), SIRET (14 chiffres). */
(function () {
  if (window.__odentisProId) return;
  window.__odentisProId = true;

  var KEY = 'RPPS ou SIRET';
  var SEL = '[data-pro-id]';
  var last = '';

  function clean(v) { return String(v || '').replace(/[\s.\-]/g, ''); }   /* \s couvre aussi l'espace insécable */
  function valid(v) {
    var d = clean(v);
    return /^\d+$/.test(d) && (d.length === 9 || d.length === 11 || d.length === 14);
  }
  function all() { return [].slice.call(document.querySelectorAll(SEL)); }
  function show(input, bad) {
    var box = input.closest('[data-pro-field]');
    var err = box && box.querySelector('[data-pro-error]');
    input.setAttribute('aria-invalid', bad ? 'true' : 'false');
    if (box) box.classList.toggle('is-invalid', !!bad);
    if (err) err.hidden = !bad;
  }

  /* mémorise la valeur sur le panier, sans recharger le tiroir, pour qu'elle survive
     à un rafraîchissement du panier ou à un changement de page */
  function save(value) {
    var attrs = {}; attrs[KEY] = value;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches(SEL)) return;
    if (t.getAttribute('aria-invalid') === 'true' && valid(t.value)) show(t, false);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches(SEL)) return;
    var v = clean(t.value);
    if (v && !valid(v)) { show(t, true); return; }
    show(t, false);
    t.value = v;
    last = v;
    all().forEach(function (o) { if (o !== t) o.value = v; });
    save(v);
  });

  /* bloque le passage en caisse tant que le numéro est absent ou mal formé.
     Phase de capture : le formulaire du panier est en novalidate, la validation du navigateur ne s'applique pas. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    var input = f.querySelector(SEL);
    if (!input) return;
    if (!valid(input.value)) {
      e.preventDefault();
      e.stopPropagation();
      show(input, true);
      input.focus();
      return;
    }
    input.value = clean(input.value);
  }, true);

  /* le tiroir est re-rendu par le serveur à chaque changement de quantité : on remet la valeur saisie */
  var first = all()[0];
  if (first && first.value) last = first.value;
  var drawer = document.getElementById('cart');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (!last) return;
      all().forEach(function (i) { if (!i.value) i.value = last; });
    }).observe(drawer, { childList: true });
  }
})();
